import React, { useEffect } from 'react';
import { STDStyle, Buttons } from '../style';
import Std from '../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';
import Button from '@/components/ButtonHome';
import ButtonBack from '@/components/ButtonBack';
import LoadingScreen from '@/components/LoadingScreen';
import ShadowBack from '@/components/ShadowBack';
import axios from 'axios'

import { api } from "@/utils/http";
import { useState } from 'react';


const Welcome = () => {

  const [loading, setLoading] = useState(false)

  const goToLogin = async (eapp) => {
    try {
      setLoading(true)
      const path = eapp ? `/auth/oidc/start` : "/auth/login-web";
      const params = eapp
        ? {
          client_id: "vw-newsletter", // exemplo
          redirect_uri: `https://www.qa-e-app-volkswagenportugal.site/x7a9/ui/callback`,
        }
        : {
          client_id: "",
          redirect_uri: "",
        };
      console.log('path', path)

      const { data } = await api.get(path, { params, responseType: "json" });
      console.log(data)
      window.location.assign(data.redirect_to);
    } catch (error) {
      setLoading(false)
      console.log(error)
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 200);
    }

  };


  return (
    <Std id='front' withoutMenu={true}>
      {loading && <LoadingScreen />}
      <STDStyle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '50px' }} >
          <Text title={w.Welcome_title} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h2' />
          <Buttons>
            <Button handle={() => goToLogin(false)} text="Login" />
          </Buttons>
          <Buttons>
            <ButtonBack minWid={'180px'} handle={() => goToLogin(true)} text="PasswordLess" />
          </Buttons> 

        </div>
      </STDStyle>
    </Std>
  );
};

export default Welcome;
